<igx-card class="neo-card-borderless">
  <igx-card-content>
    <div class="layout-box" igxLayout igxLayoutDir="column" style="gap: 1.5rem;">
      <!-- Primera fila: Tamaño de hoja y Orientación -->
      <div class="row-container" igxLayout igxLayoutDir="row" style="gap: 1rem;">
        <div class="column-item">
          <div class="option-with-icon">
            <igx-icon name="description" class="option-icon"></igx-icon>
            <igx-select [(ngModel)]="opciones.pageSize" style="width: 100%">
              <label igxLabel>{{ 'MENSAJES.PDF.TAMANO_HOJA' | translate }}</label>
              @for (size of pageSizes; track size) {
              <igx-select-item [value]="size">
                {{ size }}
              </igx-select-item>
              }
            </igx-select>
          </div>
        </div>
        <div class="column-item">
          <div class="option-with-icon">
            <igx-icon name="screen_rotation" class="option-icon"></igx-icon>
            <igx-select [(ngModel)]="opciones.pageOrientation" style="width: 100%">
              <label igxLabel>{{ 'MENSAJES.PDF.ORIENTACION_PAGINA' | translate }}</label>
              <igx-select-item value="portrait">
                {{ 'MENSAJES.PDF.VERTICAL' | translate }}
              </igx-select-item>
              <igx-select-item value="landscape">
                {{ 'MENSAJES.PDF.HORIZONTAL' | translate }}
              </igx-select-item>
            </igx-select>
          </div>
        </div>
      </div>

      <!-- Segunda fila: Mostrar bordes y Tamaño de fuente -->
      <div class="row-container" igxLayout igxLayoutDir="row" style="gap: 1rem;">
        <div class="column-item">
          <div class="option-with-icon">
            <igx-icon name="border_all" class="option-icon"></igx-icon>
            <igx-checkbox [(ngModel)]="opciones.showTableBorders">
              {{ 'MENSAJES.PDF.MOSTRAR_BORDES_TABLA' | translate }}
            </igx-checkbox>
          </div>
        </div>
        <div class="column-item">
          <div class="option-with-icon">
            <igx-icon name="format_size" class="option-icon"></igx-icon>
            <igx-input-group style="width: 100%">
              <label igxLabel>{{ 'MENSAJES.PDF.TAMANO_FUENTE' | translate }}</label>
              <input igxInput type="number" [(ngModel)]="opciones.fontSize" min="6" max="72" />
            </igx-input-group>
          </div>
        </div>
      </div>

      <!-- Advertencia -->
      <div class="advertencia-container">
        <igx-icon name="warning" class="advertencia-icon"></igx-icon>
        <span class="advertencia-texto">{{ 'MENSAJES.PDF.ADVERTENCIA_COLUMNAS' | translate }}</span>
      </div>
    </div>
  </igx-card-content>
</igx-card>
